// extracted by mini-css-extract-plugin
export default {"reviewPhotoGallery":"pp-z","imageAndVideoCount":"qp-z","imageAndVideoContainer":"rp-z","viewAllReviews":"sp-z"};